(function($) {
  $(document).ready(function() {
  	
    $(".teams-container .details, .teams-container .overlay").hide();
    
    $(".teams-container .front").on("click", function() {
    	$(this).parent().find(".details").fadeToggle();
      	$(".teams-container .overlay").fadeToggle();
    });
    
    $(".teams-container .close").on("click", function() {
    	$(this).parent().fadeToggle();
      	$(".teams-container .overlay").fadeToggle();
    });
  
  });

  
  /*=============================*/
  /*=== Read More / Read Less ===*/
  /*=============================*/
  var txt = 'Read Description';
    
  $(".product-single__description > *").first().nextAll().wrapAll('<div class="readmore-content"></div>'); 
  $(".readmore-content").hide();
  $(".readmore-content").after('<div class="readmorebtn-wrapper"><a href="#" class="readmorebtn"><span class="text">' + txt + '</span></a></div>');
  
  $(".readmorebtn").on("click", function(e) {
    e.preventDefault();
    txt = $(this).parent().prev(".readmore-content").is(':visible') ? 'Read Description' : 'Hide Description';
    $(this).text(txt);
    $(this).parent().prev(".readmore-content").slideToggle(200);
  });

})(jQuery);

function actionMoreLess(){
  var boxOuter = ".data_more_less",
      boxInner = ".data_more_less_inner",
      boxBody = ".data_more_less_body",
      showMore = $(".action_more"),
      showLess = $(".action_less");
  $(boxInner).each(function(){
    var $this = $(this),
        bodyDataH = $this.find(boxBody).height();
    $this.css("max-height", $this.data("height"));
    var $thisH = $this.height();
    if(bodyDataH > $thisH){
        $this.closest(boxOuter).removeClass("action_disabled");
    } else {
      $this.closest(boxOuter).addClass("action_disabled");
    }
  })
  showMore.click(function(e){
    e.preventDefault();
    var $this = $(this),
        boxInnerH = $this.closest(boxOuter).find(boxInner).height(),
        boxInnerUpdate = boxInnerH + $this.closest(boxOuter).find(boxInner).data("increase-by"),
        boxBodyH = $this.closest(boxOuter).find(boxBody).height();
      setTimeout(function(){
        if(boxBodyH > boxInnerUpdate){
          $this.closest(boxOuter).removeClass("less_active").find(boxInner).css("max-height", boxInnerUpdate);
        } else {
          $this.closest(boxOuter).addClass("less_active").find(boxInner).css("max-height", "none");
        }
      },10);
  });
    showLess.click(function(){
      $(this).closest(boxOuter).removeClass("less_active").find(boxInner).css("max-height", $(this).closest(boxOuter).find(boxInner).data("height"));
      return false;
    });
} actionMoreLess();